import React, { createContext, useCallback, useContext, useEffect, useRef, useState, useMemo, } from 'react';
const FootnoteContext = createContext({});
export function FootnoteContextProvider({ children, footnoteReferenceService, }) {
    const [footnotes, setFootnotes] = useState([]);
    const callbacksByReference = useRef(new Map());
    const registerFootnoteReference = useCallback((reference, callback) => {
        let callbacks = callbacksByReference.current.get(reference);
        if (callbacks) {
            callbacks.add(callback);
        }
        else {
            callbacks = new Set([callback]);
            callbacksByReference.current.set(reference, callbacks);
        }
        footnoteReferenceService.addFootnoteReferences([reference]);
        return () => callbacks.delete(callback);
    }, []);
    useEffect(() => {
        footnoteReferenceService.registerCallback(setFootnotes);
        return () => {
            footnoteReferenceService.unregisterCallback();
            callbacksByReference.current.clear();
        };
    }, []);
    useEffect(() => {
        for (const footnote of footnotes) {
            const callbacks = callbacksByReference.current.get(footnote.id);
            if (callbacks) {
                for (const callback of callbacks) {
                    callback(footnote);
                }
            }
        }
    }, [footnotes]);
    const contextValue = useMemo(() => ({ registerFootnoteReference }), [registerFootnoteReference]);
    return React.createElement(FootnoteContext.Provider, { value: contextValue }, children);
}
export function useFootnotesService(footnoteId) {
    const { registerFootnoteReference } = useContext(FootnoteContext);
    const [footnote, setFootnote] = useState();
    if (!registerFootnoteReference) {
        throw new Error(`'registerFootnoteReference' couldn't be found.
    Did you forget to add 'FootnoteContextProvider'?
    You need to wrap your components with this provider to use footnotes:
    <FootnoteContextProvider footnoteReferenceService={footnoteReferenceService}>
      <YOUR_COMPONENT />
    </FootnoteContextProvider>`);
    }
    useEffect(() => registerFootnoteReference(footnoteId, setFootnote), [footnoteId]);
    return footnote;
}
//# sourceMappingURL=use-footnote-service.js.map